import { ref } from 'vue'
import * as yup from 'yup'
import type { Ref } from 'vue'
export function useAllCsvDownload(
  tableData: Ref<Array<any>>,
  schema: yup.Schema,
  header: Array<String>,
  filename: String
) {
  const filtered = tableData; //ref(tableData)

  /**
   * download all the filtered data as .csv file
   */
  async function downloadAllCsv() {
    console.log('download csv button clicked...')
    const separator = ';' //USE SOMETHING OTHER THAN COMMA
    const csvHeader = header?.join(separator)
    let csvData = csvHeader + '\n'
    const endRow = filtered.value.length
    for (let i = 0; i < endRow; i++) {
      const row = filtered.value[i]
      //parse with yup
      let parsed
      try {
        parsed = await schema.validate(row, { stripUnknown: true }) //remove extra fields
      } catch (err) {
        console.log('error parsing csv row:')
        console.log(err)
      }

      if (parsed) {
        const csvRow = header
          ?.map((key) => {
            //TODO some fields have commas in them, remove or replace?
            const val = JSON.stringify(parsed[key])
            return val
          })
          .join(separator)

        csvData = csvData + csvRow + '\n' // + '\n';
      } else {
        console.log('error on parsing row ' + i)
      }
    }
    
    //download the blob data
    const CSVFile = new Blob([csvData], { type: 'text/csv' })
    // Create to temporary link to initiate
    // download process
    const temp_link = document.createElement('a')

    // Download csv file
    temp_link.download = `${filename}.csv` //'all_data.csv';
    const url = window.URL.createObjectURL(CSVFile)
    temp_link.href = url

    // This link should not be displayed
    temp_link.style.display = 'none'
    document.body.appendChild(temp_link)

    // Automatically click the link to trigger download
    temp_link.click()
    document.body.removeChild(temp_link)
  }
  return { downloadAllCsv }
}
